export const REQUEST_DUE_DILIGENCE_ATTEMPT = 'REQUEST_DUE_DILIGENCE_ATTEMPT';
export type REQUEST_DUE_DILIGENCE_ATTEMPT = typeof REQUEST_DUE_DILIGENCE_ATTEMPT;

export const REQUEST_DUE_DILIGENCE_SUCCESS = 'REQUEST_DUE_DILIGENCE_SUCCESS';
export type REQUEST_DUE_DILIGENCE_SUCCESS = typeof REQUEST_DUE_DILIGENCE_SUCCESS;

export const REQUEST_DUE_DILIGENCE_FAILURE = 'REQUEST_DUE_DILIGENCE_FAILURE';
export type REQUEST_DUE_DILIGENCE_FAILURE = typeof REQUEST_DUE_DILIGENCE_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/due-diligence/Types.tsx